import { defaultFontFamilyOptions } from 'app/pages/design/landingPageBuilder/components';
import {
  LP_DESIGN_CATEGORIES,
  FontSizes,
  LP_DESIGN_COMMON_COLORS,
  TEXT_ALIGNMENT,
  TEXT_ORIENTATION,
  LP_DESIGN_SOCIAL_MEDIA,
  GRADIENT_TYPES,
  FONT_CASE_KEYWORD,
  FONT_WEIGHT_KEYWORD,
  getLandingPageBuilderLogos,
} from '../constants';
import {
  ILandingPageBuilderForm,
  ILandingPageDesignResponse,
  IUIKitFormData,
} from '../types';
import { BODY_ORIENTATION } from '../components/modal/LandingPageBuilderModal';
import { ICombinedUserData } from 'lib/context';

interface IInitialLandingPageValuesParams {
  uiKitsResponse: IUIKitFormData[] | null;
  userData: ICombinedUserData;
  isCdkUser: boolean;
  templateDesign?: ILandingPageDesignResponse;
}

export const getInitialLandingPageValues = ({
  uiKitsResponse,
  userData,
  isCdkUser,
  templateDesign,
}: IInitialLandingPageValuesParams): ILandingPageBuilderForm => {
  const footerLogo =
    templateDesign?.footerLogo ||
    getLandingPageBuilderLogos(userData.superAdminRole, isCdkUser)[0].value;
  return {
    title: templateDesign?.title || '',
    category: templateDesign?.category || LP_DESIGN_CATEGORIES.OEM,
    fontFamily: templateDesign?.fontFamily || defaultFontFamilyOptions[0].value,
    bodyFontSize: templateDesign?.bodyFontSize || FontSizes[2].value,
    bodyTextColor:
      templateDesign?.bodyTextColor || LP_DESIGN_COMMON_COLORS.BLACK,
    textColor: templateDesign?.textColor || LP_DESIGN_COMMON_COLORS.BLACK,
    buttonColor: templateDesign?.buttonColor || LP_DESIGN_COMMON_COLORS.BLACK,
    buttonHoverColor:
      templateDesign?.buttonHoverColor || LP_DESIGN_COMMON_COLORS.BLACK,
    bodyBackgroundImage: {
      url: templateDesign?.bodyBackgroundImage || '',
      file: null,
    },
    headerLogo: {
      url: templateDesign?.headerLogo || '',
      file: null,
    },
    showButtonBorder: templateDesign?.showButtonBorder ?? 0,
    buttonFontCase:
      templateDesign?.buttonFontCase || FONT_CASE_KEYWORD.CAPITALIZED,
    buttonFontWeight:
      templateDesign?.buttonFontWeight || FONT_WEIGHT_KEYWORD.REGULAR,
    buttonFontFamily:
      templateDesign?.buttonFontFamily || defaultFontFamilyOptions[0].value,
    buttonFontSize: templateDesign?.buttonFontSize || FontSizes[2].value,
    buttonLineHeight: templateDesign?.buttonLineHeight || 0,
    buttonCornerRadius: templateDesign?.buttonCornerRadius || 0,
    buttonPaddingY: templateDesign?.buttonPaddingY || 16,
    buttonPaddingX: templateDesign?.buttonPaddingX || 32,
    buttonBorderColor:
      templateDesign?.buttonBorderColor || LP_DESIGN_COMMON_COLORS.BLACK,
    buttonBorderHoverColor:
      templateDesign?.buttonBorderHoverColor || LP_DESIGN_COMMON_COLORS.BLACK,
    buttonTextColor:
      templateDesign?.buttonTextColor || LP_DESIGN_COMMON_COLORS.WHITE,
    buttonTextHoverColor:
      templateDesign?.buttonTextHoverColor || LP_DESIGN_COMMON_COLORS.WHITE,
    bodyBackgroundColor:
      templateDesign?.bodyBackgroundColor || LP_DESIGN_COMMON_COLORS.GRAY20,
    additionalText: templateDesign?.additionalText || '',
    additionalTextBackgroundColor:
      templateDesign?.additionalTextBackgroundColor ||
      LP_DESIGN_COMMON_COLORS.WHITE,
    additionalTextColor:
      templateDesign?.additionalTextColor || LP_DESIGN_COMMON_COLORS.BLACK,
    additionalTextFontFamily:
      templateDesign?.additionalTextFontFamily ||
      defaultFontFamilyOptions[0].value,
    bodyOrientation: templateDesign?.bodyOrientation || BODY_ORIENTATION.center,
    headerBackgroundColor:
      templateDesign?.headerBackgroundColor || LP_DESIGN_COMMON_COLORS.GRAY40,
    headerTextColor:
      templateDesign?.headerTextColor || LP_DESIGN_COMMON_COLORS.BLACK,
    showContactIcons: templateDesign?.showContactIcons ?? 1,
    showFirstName: templateDesign?.showFirstName ?? 0,
    showLastName: templateDesign?.showLastName ?? 0,
    showPhone1: templateDesign?.showPhone1 ?? 1,
    showPhone2: templateDesign?.showPhone2 ?? 0,
    showDepartment: templateDesign?.showDepartment ?? 0,
    showTitle: templateDesign?.showTitle ?? 0,
    showWebsite: templateDesign?.showWebsite ?? 0,
    showEmail: templateDesign?.showEmail ?? 1,
    showHeaderShadow: templateDesign?.showHeaderShadow ?? 0,
    showFooterShadow: templateDesign?.showFooterShadow ?? 0,
    headerLogoMaxWidth: templateDesign?.headerLogoMaxWidth || 220,
    headerLogoMaxHeight: templateDesign?.headerLogoMaxHeight || 85,
    headerContentAlignment:
      templateDesign?.headerContentAlignment || TEXT_ALIGNMENT.LEFT,
    headerContentOrientation:
      templateDesign?.headerContentOrientation || TEXT_ORIENTATION.HORIZONTAL,
    headerFontCase:
      templateDesign?.headerFontCase || FONT_CASE_KEYWORD.CAPITALIZED,
    headerFontWeight:
      templateDesign?.headerFontWeight || FONT_WEIGHT_KEYWORD.REGULAR,
    titleFontSize: templateDesign?.titleFontSize || FontSizes[3].value,
    headerLineHeight: templateDesign?.headerLineHeight || 0,
    headerFontFamily:
      templateDesign?.headerFontFamily || defaultFontFamilyOptions[0].value,
    footerBackgroundColor:
      templateDesign?.footerBackgroundColor || LP_DESIGN_COMMON_COLORS.GRAY40,
    footerLogo,
    showSocialMediaIcons: templateDesign?.showSocialMediaIcons ?? 0,
    socialMediaIconType:
      templateDesign?.socialMediaIconType ||
      LP_DESIGN_SOCIAL_MEDIA.WHITE_SQUARE,
    showGradient: templateDesign?.showGradient ?? 0,
    gradient: templateDesign?.gradient || GRADIENT_TYPES.DARK,
    uiKits: uiKitsResponse || [],
    access: {},
    selectedResellerId: -1,
  };
};
